export default "__VITE_ASSET__B_EQN0kF__"